import * as React from "react";
import {
  CellContext,
  ColumnDef,
  createColumnHelper,
  HeaderContext
} from "@tanstack/react-table";

import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import { customCreateColumnHelper } from "src/core/dashboard/components/widgets/table/customColumnHelper";
import { SelectableCustomer } from "src/pages/Admin/CustomersAndUsers/Customer/Users/UserCustomers/UserAssignedCustomerTab";

export interface IAssignedCustomersTableColumns {
  checkboxAction: (data: SelectableCustomer) => void,
  bulkActionButton: (info: HeaderContext<SelectableCustomer, unknown>) => React.ReactNode,
  actionButton: (info: CellContext<SelectableCustomer, unknown>) => React.ReactNode,
  terminology: ITerminology
  columns?: CustomerUserDropColumnsPicked[]
}

type CustomerUserDropColumnsPicked = keyof AvailableCustomerUserCustomersTableColumns;

interface AvailableCustomerUserCustomersTableColumns{
  bulkActionCheck: ColumnDef<SelectableCustomer, undefined>,
  accountNumber: ColumnDef<SelectableCustomer, undefined>,
  name: ColumnDef<SelectableCustomer, undefined>,
  actions: ColumnDef<SelectableCustomer, unknown>,
}

/** columns for Customers the are assigned to a user inc selecting feature*/
export const getUserAssignedCustomerTableColumns = (params: IAssignedCustomersTableColumns) => {
  const customDropColumnHelper = customCreateColumnHelper<SelectableCustomer>();
  const dropColumnHelper = createColumnHelper<SelectableCustomer>();

  const AllColumns: AvailableCustomerUserCustomersTableColumns = {
    bulkActionCheck: customDropColumnHelper.checkboxColumn(dropColumnHelper, {
      enableColumnFilter: false,
      enableSorting: false
    }, "selected", params.checkboxAction, params.bulkActionButton),

    accountNumber: customDropColumnHelper.standardTextColumn(dropColumnHelper, "accountNumber", {
      header: "Account Number",
      size: 200
    }),
    name: customDropColumnHelper.standardTextColumn(dropColumnHelper, "name", { header: "name" }),

    actions: customDropColumnHelper.actionColumn(dropColumnHelper, params.actionButton, {})
  };

  if (params.columns) {
    return params.columns.map(column => AllColumns[ column ]);
  } else {
    return Object.values(AllColumns);
  }
};
